import { tokens } from '@opendoor/tokens-studio/dist/bricks-next/tokens/Components';

import { isKeyOfObject } from '../../../../helpers/utils';
import { Box } from '../../../Box';
import { Text } from '../../../Text';
import type { SingleRadioProps } from '../RadioGroup';
import type { SharedSingleCheckboxRadioProps } from './types';

const { radioCheckbox } = tokens;

/**
 * Label for checkbox and radio components
 */
export const CheckboxRadioLabel = ({
  size,
  label,
  subtitle,
  id,
  state,
}: Pick<SharedSingleCheckboxRadioProps, 'size' | 'label' | 'subtitle' | 'id' | 'state'>) => (
  <Box alignSelf="center" flex={3}>
    <Text
      alignSelf="flex-start"
      tag="label"
      numberOfLines={1}
      htmlFor={id}
      typography={radioCheckbox.typography.valueText[size]}
      fontWeight={
        isKeyOfObject(size, radioCheckbox.fontWeight.override)
          ? radioCheckbox.fontWeight.override[size]
          : undefined
      }
      color={
        isKeyOfObject(state, radioCheckbox.color.content.valueText.state)
          ? radioCheckbox.color.content.valueText.state[state]
          : radioCheckbox.color.content.valueText.default
      }
    >
      {label}
    </Text>

    {!!subtitle && (
      <Text
        alignSelf="flex-start"
        tag="span"
        numberOfLines={1}
        typography={radioCheckbox.typography.valueTextSecondLine[size]}
        color={
          isKeyOfObject(state, radioCheckbox.color.content.valueTextRowTwo.state)
            ? radioCheckbox.color.content.valueTextRowTwo.state[state]
            : radioCheckbox.color.content.valueTextRowTwo.default
        }
      >
        {subtitle}
      </Text>
    )}
  </Box>
);

/**
 * Right aligned text for radio components
 */
export const RightAlignedRadioLabel = ({
  size,
  rightAlignedText,
  state,
}: Pick<SingleRadioProps, 'rightAlignedText'> &
  Pick<SharedSingleCheckboxRadioProps, 'size' | 'state'>) => (
  <Box alignSelf="center" flex={1}>
    <Text
      alignSelf="flex-end"
      tag="label"
      numberOfLines={1}
      typography={radioCheckbox.typography.rightAligned[size]}
      color={
        isKeyOfObject(state, radioCheckbox.color.content.valueText.state)
          ? radioCheckbox.color.content.valueText.state[state]
          : radioCheckbox.color.content.valueText.default
      }
      paddingRight={size === 'xsmall' ? '$6x' : 0}
    >
      {rightAlignedText}
    </Text>
  </Box>
);
